<script setup lang="ts">
    import { Employee } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditEmployee from '@/components/employees/EditEmployee.vue';
    import TerminateEmployee from '@/components/employees/TerminateEmployee.vue';
    import Permission from '@/enums/Permission';
    import Delete from '@/components/Delete.vue';
    import { useRoles } from '@/composables/useRoles';
    import Role from '@/enums/Role';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';

    defineProps<{
        employee: Employee;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { hasPermission } = usePermissions();
    const { hasAnyRole } = useRoles();
</script>

<template>
    <DataTableActions :data="employee">
        <EditEmployee
            v-if="hasPermission(Permission.EMPLOYEES_UPDATE)"
            :employee="employee"
        />
        <TerminateEmployee
            v-if="hasPermission(Permission.EMPLOYEES_UPDATE)"
            :employee="employee"
        />
        <Delete
            v-if="hasAnyRole([Role.SUPER_ADMIN, Role.PAYROLL])"
            :route="route('v2.salary.employee.delete', { employeeId: employee.id })"
            :query-key="[QueryKey.EMPLOYEES, selectedCompanyId]"
            header="employee.validation.are_you_sure"
            description="employee.validation.delete_employee_confirm_text"
        />
    </DataTableActions>
</template>
